import React, { useEffect } from 'react';
import { MenuList } from '@mui/material';

import { InsertableObjectMenuItems } from './InsertableObjectMenuItems';
import { useInsertableObjectsMenuInternals } from './useInsertableObjectsMenu';

interface Props {
  monitorText: string;
  onChooseItem: () => void;
}

export function AddItemMenu({ monitorText, onChooseItem }: Props) {
  const { insertableObjects, insert, handleHotCharacterKeyDown } = useInsertableObjectsMenuInternals(
    monitorText,
    onChooseItem,
  );

  const active = insertableObjects.length > 0;

  useEffect(() => {
    if (!active) return;

    document.addEventListener('keydown', handleHotCharacterKeyDown);
    return () => document.removeEventListener('keydown', handleHotCharacterKeyDown);
  }, [active, handleHotCharacterKeyDown]);

  if (!active) return null;

  return (
    <MenuList dense>
      <InsertableObjectMenuItems
        monitorText={monitorText}
        onChooseItem={onChooseItem}
        insert={insert}
        insertableObjects={insertableObjects}
      />
    </MenuList>
  );
}
